import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";
import { createToast } from "../components/ui/toast";
import Sidebar from "../components/Sidebar";
import DashboardLayout from "../components/dashboard/DashboardLayout";
import WaiterMode from "../components/dashboard/WaiterMode";
import Tables from "./tables/Tables";
import ShowTables from "./tables/ShowTables/ShowTables";
import Categorias from "./categorias/Categorias";
import AdminCategories from "./MostrarCategorias/AdminCategorias";
import ProductForm from "./productos/ProductForm";
import AdminProducts from "./AdminProducts/AdminProducts";
import LoadingSpinner from "../components/common/LoadingSpinner";
import ErrorAlert from "../components/common/ErrorAlert";
import MultiPrinterConfig from "./printer/MultiPrinterConfig";
import ArqueoComponent from "./printer/ArqueoComponent";
import { useOrderPrinting } from "../hooks/useOrderPrinting";
import { useOrdersPolling } from "../hooks/useOrdersPolling";
import { usePaymentProcessor } from "../hooks/usePaymentProcessor";

const RestaurantDashboard = () => {
  useOrderPrinting();
  usePaymentProcessor();
  //  useOrderPrintingBar();
  //  useOrderPrintingKitchen();

  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [currentView, setCurrentView] = useState("camarero");
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingProduct, setEditingProduct] = useState(null);
  const navigate = useNavigate();

  // Usar el nuevo hook de polling para mantener las órdenes actualizadas
  const { orders, isLoading, error, refreshOrders } = useOrdersPolling(5000);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsSidebarOpen(!mobile);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getTotal = (products) => {
    return products
      .reduce(
        (sum, product) => sum + product.total * (product.quantity || 1),
        0
      )
      .toFixed(2);
  };

  const handleLogout = () => {
    authService.logout();
    navigate("/");
  };

  const renderContent = () => {
    if (isLoading && currentView === "camarero") return <LoadingSpinner />;
    if (error && currentView === "camarero")
      return <ErrorAlert message={error} onRetry={refreshOrders} />;

    const views = {
      camarero: (
        <WaiterMode
          orders={orders}
          getTotal={getTotal}
          onOrdersUpdate={refreshOrders}
        />
      ),
      mesas: <Tables />,
      mostrarMesas: <ShowTables />,
      categorias: (
        <Categorias
          editingCategory={editingCategory}
          setEditingCategory={setEditingCategory}
        />
      ),
      admCategorias: (
        <AdminCategories
          setCurrentView={setCurrentView}
          setEditingCategory={setEditingCategory}
        />
      ),
      productos: (
        <ProductForm
          editingProduct={editingProduct}
          setEditingProduct={setEditingProduct}
        />
      ),
      admProductos: (
        <AdminProducts
          setCurrentView={setCurrentView}
          setEditingProduct={setEditingProduct}
        />
      ),
      configuracionMultiplesImpresoras: <MultiPrinterConfig />,
      arqueo: <ArqueoComponent />,
      barra: <div>Página Barra</div>,
      cocina: <div>Página Cocina</div>,
      historico: <div>Página Histórico</div>,
    };

    return views[currentView] || null;
  };

  return (
    <DashboardLayout
      isMobile={isMobile}
      isSidebarOpen={isSidebarOpen}
      setIsSidebarOpen={setIsSidebarOpen}
      currentView={currentView}
    >
      <Sidebar
        isMobile={isMobile}
        isSidebarOpen={isSidebarOpen}
        currentView={currentView}
        setIsSidebarOpen={setIsSidebarOpen}
        setCurrentView={setCurrentView}
        onLogout={handleLogout}
      />

      {renderContent()}
    </DashboardLayout>
  );
};

export default RestaurantDashboard;
